import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { Subscription, Subscriber } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import AppResponseError from 'src/app/shared/models/app-response-error';
import { EmpresaContratante } from 'src/app/shared/models/dados-contratante';
import { ConfirmacaoModalComponent } from '../../modal/components/confirmacao-modal/confirmacao-modal.component';
import { MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import {
  StepNavigatorService
} from 'src/app/shared/components/multi-step-navigator/components/step-navigator/services/step-navigator.service';
import { TokenLogin } from 'src/app/shared/models/login-response';
import { trackAmplitudeEvent, SETUP_STEP_COMPLETED_EVENT, SETUP_COMPLETED_EVENT } from 'src/app/shared/services/amplitude.config';
import { MultiStepService } from 'src/app/shared/components/multi-step-navigator/services/multi-step.service';

@Component({
  selector: 'app-download-uploader',
  templateUrl: './download-uploader.component.html',
  styleUrls: ['./download-uploader.component.scss']
})
export class DownloadUploaderComponent implements OnInit, OnDestroy {

  public ultimaVersao: string = undefined;
  private subscriptions: Subscription[] = [];
  public contratante: EmpresaContratante = undefined;
  private baixouUploader = false;

  constructor(
    private apiService: ApiService,
    private toaster: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private stepNavigator: StepNavigatorService,
    private multiStepService: MultiStepService,
  ) { }

  ngOnInit() {
    const sub1 = this.apiService.obterUltimaVersaoUploader().subscribe((ret: { versao: string }) => {
      this.ultimaVersao = ret.versao;
    });
    this.subscriptions.push(sub1);


    const sub2 = this.apiService.obterDadosContratante().subscribe(
      {
        next: (ec) => {
          this.contratante = ec;
        }
      }
    );
    this.subscriptions.push(sub2);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      if (sub) {
        sub.unsubscribe();
      }
    });
  }


  baixarUploader(): void {
    this.apiService.baixarUploader()
      .subscribe({
        next: (response) => {
          this.baixouUploader = true;
          window.open(response.linkDownload, '_blank');
        },
        error: (err: AppResponseError) => {
          this.toaster.error(err.descricao, err.titulo);
        }
      });
  }

  baixarManual(): void {
    this.apiService.obterLinkManualUploader().subscribe({
      next: (link: string) => {
        window.open(link, '_blank');
      },
      error: (err: AppResponseError) => {
        this.toaster.error(err.descricao, err.titulo);
      }
    });
  }

  /**
   * Função para ir ao dashboard/Terminar processo cadastral
   */
  submit() {
    // Função interna para reaproveitar código, serve para mostrar a modal abaixo:
    const fn = () => {
      const dialogRef = this.openGenericDialog(
        'Atenção!',
        'Essa ação irá encerrar o processo cadastral.',
        ['Emails serão enviados para todos os usuários cadastrados.',
          'Deseja prosseguir?']
      );
      const sub1 = dialogRef.afterClosed().subscribe(
        (data) => {
          if (data && data === true) {
            this.subscriptions.push(sub1);
            const sub = this.apiService.terminarSetup()
              .subscribe({
                next: () => {

                  // TODO: refatorar no authservice
                  const token = JSON.parse(localStorage.getItem('gsp_access_token')) as TokenLogin;

                  if (token && token.usuario) {
                    token.usuario.contratante.situacaoProcessoCadastral = 'Concluido';
                    localStorage.setItem('gsp_access_token', JSON.stringify(token));
                  }

                  trackAmplitudeEvent(SETUP_STEP_COMPLETED_EVENT, {
                    etapaConcluida: 'DownloadUploader',
                    proximaEtapa: 'Concluido'
                  });
                  trackAmplitudeEvent(SETUP_COMPLETED_EVENT);

                  this.stepNavigator.refresh().subscribe({
                    next: () => {
                      this.router.navigate(['/'], { relativeTo: this.route });
                    }
                  });
                }, error: (err: AppResponseError) => {
                  this.toaster.error(err.descricao, 'Erro ao finalizar cadastro');
                  const innerSub = this.apiService
                    .loggarErro(
                      // { conteudo: err, sessao: 'registration-review-component -> goToNextStep', logLevel: 'Error' }
                      {
                        sessao: 'cxmkdrW8A5pukFPeJrNQ6t5OenLaPIQagUDoYjXay4JETg2Fg5hn4FFzZcZLe1j0',
                        logLevel: 'oWJNjAC6qFd0kcPGmqW/pQ==', conteudo: err, criptografado: false
                      }
                    )
                    .subscribe();
                  this.subscriptions.push(innerSub);
                }
              } as Subscriber<void>);

            this.subscriptions.push(sub);
          }
        });

    };

    // Se já terminou o processo cadastral, só iremos ao dashboard.
    if (this.contratante.situacaoProcessoCadastral === 'Concluido') {
      this.router.navigate(['/'], { relativeTo: this.route });
    } else {
      // Se não, e se não baixou o uploader ainda, mostrar warning
      if (!this.baixouUploader) {
        const dialogRef = this.openGenericDialog(
          'Atenção!',
          'Percebemos que você ainda não executou o download do Gerenciador de Monitoramento de Diretórios.',
          ['Caso não configure essa ferramenta, o processo de automação de arquivos SPED não será executado!',
            'Deseja continuar mesmo assim?', '',
            'OBS.: Após finalizar o processo cadastral você poderá fazer o download a qualquer momento.'],
        );
        const sub1 = dialogRef.afterClosed().subscribe(
          (data) => {
            if (data && data === true) {
              this.baixouUploader = true;
              // Invoca modal de completar cadastro após ignorar o donwload do uploader
              fn();
            }
          });
        this.subscriptions.push(sub1);
      } else {
        // Invoca modal de completar cadastro
        fn();
      }
    }
  }

  get processoCadastralConcluido() {
    return this.contratante.situacaoProcessoCadastral === 'Concluido';
  }

  goToPreviousStep() {
    if (this.contratante.situacaoProcessoCadastral !== 'Concluido') {
      this.multiStepService.goToPreviousStep();
    }
  }

  returnDashboard() {
    this.router.navigate(['/'], { relativeTo: this.route });
  }

  /**
   * Método para abrir um modal com informações para confirmar a conclusão do setup
   *
   * @returns Referência para o modal aberto com as informações configuradas
   */
  openGenericDialog(
    title: string,
    message: string,
    extraMessage: string[] = ['']): MatDialogRef<ConfirmacaoModalComponent> {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      title,
      message,
      extraMessage
    };

    return this.dialog.open(ConfirmacaoModalComponent, dialogConfig);
  }

}
